import * as yup from 'yup'

export const createFinalInformation = yup.object({
  medias: yup.array().nullable(),
  final_information_text: yup.string().required(),
  interview_date: yup.string()
})
